var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpt-zone-action"},[_c('strong',[_vm._v("IF REMOTES")]),_vm._v(" "),_c('b-tag',{attrs:{"type":"is-success"}},[_vm._v(_vm._s(_vm.action.presence))]),_vm._v(" "),_c('strong',[_vm._v("THEN")]),_vm._v(" "),_c('b-tag',{attrs:{"type":"is-primary"}},[_vm._v(_vm._s(_vm.action.actionType))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }